module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'up-button/up-button-top' && templateVars.config ?
				templateVars.config :
				{
	"upButtonAnimation": {
		"scrollToUpDuration": 500,
		"buttonFadeIn": 300,
		"buttonFadeOut": 300
	},
	"scrollTopValue": false
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/up-button/.variant/up-button-top/config.yaml
// module id = 115
// module chunks = 0